<template>
  <div class="upload-list">
    <upload v-bind="upload" v-bind:key="upload.key" v-for="upload in uploads" v-on:delete="$emit('delete', $event)" v-bind:t="t" :openFullImageDialog="upload.key == fullImageId" :signed_in="signed_in" :canva_cta_enabled="canva_cta_enabled" :detect_objects_enabled="detect_objects_enabled" :canva_cta_variant="canva_cta_variant" />
    <div class="mt-4 text-center small" style="color: #98a0a6">
      {{ t.dont_forget_to_download }}
    </div>
  </div>
</template>

<script>
import Upload from "./upload.vue";

export default {
  props: {
    uploads: Array,
    t: Object,
    fullImageId: String,
    signed_in: Boolean,
    canva_cta_enabled: Boolean,
    detect_objects_enabled: Boolean,
    canva_cta_variant: String,
  },
  components: { Upload },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
@media (max-width: 575px) {
  .upload-list {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>
